import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { scrollToId } from "@/lib/scroll";

export const SERVICIOS = [
    {
        titulo: "Revisoría fiscal",
        descripcion:
            "Vigilancia y aseguramiento de la gestión contable, fiscal y administrativa, con informes oportunos que protegen a socios y administradores.",
    },
    {
        titulo: "Asesoría y planeación tributaria",
        descripcion:
            "Estrategia fiscal integral: renta, IVA, retenciones en la fuente, ICA y Régimen Simple de Tributación (RST), para pagar lo justo sin riesgos.",
    },
    {
        titulo: "Outsourcing contable",
        descripcion:
            "Tercerizamos tu contabilidad con registro oportuno, estados financieros confiables y acompañamiento permanente de un equipo senior.",
    },
    {
        titulo: "Implementación NIIF para PYMES",
        descripcion:
            "Diagnóstico, políticas contables y transición a NIIF para PYMES (Grupos 2 y 3), con capacitación práctica para tu equipo.",
    },
    {
        titulo: "Información exógena y facturación electrónica",
        descripcion:
            "Preparación y presentación de medios magnéticos ante la DIAN y habilitación de facturación electrónica sin contratiempos.",
    },
    {
        titulo: "Nómina y seguridad social (PILA)",
        descripcion:
            "Liquidación de nómina, prestaciones sociales y aportes PILA, con nómina electrónica y soporte ante la UGPP.",
    },
    {
        titulo: "Constitución de sociedades y trámites Cámara de Comercio",
        descripcion:
            "Creación de tu empresa, matrículas y renovaciones mercantiles, reformas estatutarias y libros corporativos ante cualquier Cámara de Comercio del país. Acompañamiento a nivel nacional, 100% virtual.",
    },
];

export default function Servicios() {
    return (
        <section id="servicios" className="relative bg-navy px-6 py-24 md:px-12 md:py-36" data-testid="servicios-section">
            <div className="mx-auto max-w-[1440px]">
                <div className="mb-16 flex flex-col gap-8 md:mb-24 md:flex-row md:items-end md:justify-between">
                    <div>
                        <motion.p
                            initial={{ opacity: 0, y: 16 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-80px" }}
                            transition={{ duration: 0.7 }}
                            className="mb-6 text-[11px] uppercase tracking-[0.3em] text-gold"
                            data-testid="servicios-overline"
                        >
                            Capítulo 01 — Servicios
                        </motion.p>
                        <motion.h2
                            initial={{ opacity: 0, y: 24 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-80px" }}
                            transition={{ duration: 0.8, delay: 0.1 }}
                            className="max-w-2xl font-display text-4xl font-medium leading-[1.05] tracking-tighter sm:text-5xl lg:text-6xl"
                            data-testid="servicios-heading"
                        >
                            Todo lo que tu empresa necesita, bajo un mismo techo contable.
                        </motion.h2>
                    </div>
                    <motion.span
                        initial={{ opacity: 0 }}
                        whileInView={{ opacity: 1 }}
                        viewport={{ once: true }}
                        transition={{ duration: 1, delay: 0.2 }}
                        className="hidden select-none font-display text-[10rem] leading-none text-white/5 lg:block"
                        aria-hidden="true"
                    >
                        01
                    </motion.span>
                </div>

                <div>
                    {SERVICIOS.map((s, i) => (
                        <motion.button
                            key={s.titulo}
                            onClick={() => scrollToId("contacto")}
                            initial={{ opacity: 0, y: 32 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-60px" }}
                            transition={{ duration: 0.7, delay: i * 0.06, ease: [0.16, 1, 0.3, 1] }}
                            className="group grid w-full grid-cols-[auto_1fr_auto] items-start gap-6 border-t border-white/10 py-8 text-left transition-colors duration-300 last:border-b hover:bg-white/[0.03] md:grid-cols-[90px_1fr_1fr_auto] md:items-center md:gap-10 md:px-6 md:py-10"
                            data-testid={`service-item-0${i + 1}`}
                        >
                            <span className="font-display text-lg text-[#9CA3AF] transition-colors duration-300 group-hover:text-gold md:text-xl">
                                {String(i + 1).padStart(2, "0")}
                            </span>
                            <h3 className="font-display text-2xl font-medium leading-tight tracking-tight text-[#F8F9FA] transition-colors duration-300 group-hover:text-gold-soft md:text-3xl">
                                {s.titulo}
                            </h3>
                            <p className="col-span-3 max-w-xl text-sm leading-relaxed text-[#9CA3AF] md:col-span-1 md:col-start-3">
                                {s.descripcion}
                            </p>
                            <ArrowUpRight
                                size={26}
                                className="col-start-3 row-start-1 text-[#9CA3AF] transition-all duration-300 group-hover:-translate-y-1 group-hover:translate-x-1 group-hover:text-gold md:col-start-4"
                            />
                        </motion.button>
                    ))}
                </div>
            </div>
        </section>
    );
}
